import { useQuery } from "@tanstack/react-query";

import { tarefaService } from "@/services/api/tarefa.service";

interface UseSituacaoTarefasOptions {
  enabled?: boolean;
}

/**
 * Situação de atraso das tarefas do usuário logado. O backend é a fonte da
 * verdade: retorna quantas estão vencidas, o maior atraso e o nível derivado.
 */
export function useSituacaoTarefas({ enabled = true }: UseSituacaoTarefasOptions = {}) {
  return useQuery({
    queryKey: ["tarefas", "minha-situacao"],
    queryFn: () => tarefaService.getMinhaSituacao(),
    enabled,
    staleTime: 1000 * 60 * 5,
  });
}
